import { useCallback } from "react";
import { store } from "src/redux/store";
import { selectIsAutosaveBlocked } from "src/redux/selectors/selectIsAutosaveBlocked";
import { useDispatch } from "src/redux/hooks";

import { triggerAutosaveForExternalChange } from "./autosaveScheduler";

export const useTriggerAutoSave = () => {
  const dispatch = useDispatch();
  return useCallback(() => {
    if (selectIsAutosaveBlocked(store.getState())) return;
    triggerAutosaveForExternalChange(dispatch);
  }, [dispatch]);
};
